<template>
  <div class="container-fluid auth-page bg-dark" dir="rtl">
    <div class="row mt-lg-6">
      <div class="col-lg-4 col-12"></div>
      <div class="col-lg-4 col-12">
        <div class="w-100 Rounded p-4">
          <h3 class="text-center">
            <i class="fas fa-circle text-danger"></i> &nbsp;&nbsp;
            <span style="color: #fff !important">بازیابی رمز عبور</span>
          </h3>
        </div>
      </div>
      <div class="col-lg-4 col-12"></div>
      <div class="col-lg-4 col-12"></div>
      <div class="col-lg-4 col-12 px-5">
        <div class="w-100 Rounded p-4 bg-light" style="min-height: 45vh !important">
          <div class="row p-4">
            <div class="col-12">
              <a  class="d-inline float-right ml-3 mt-1" href="javascript:;" @click="$router.go(-1)">
              <h5><i class="fad fa-arrow-right text-secondary"></i></h5>
            </a>
              <h3 class="text-center mb-4">سامانه جامع پاسارگاد</h3>
            </div>
            
          </div>
          <div v-if="stage == 1" class="row px-4 pb-4">
            <div class="col-12">
              <span class="mt-5">برای بازیابی رمز عبور شماره تلفن همراه خود را وارد کنید</span>
            </div>
            <div class="col-12 mt-5 pt-5">
              <input type="text" class="form-control no-border text-center" placeholder="شماره همراه" v-model="PhoneNumber" />
            </div>
            <div class="col-12 mt-2 px-4">
              <button @click="SemdSMS()" class="btn-dark w-100 mt-5 btn">بازیابی رمز عبور</button>
            </div>
          </div>
          <div v-if="stage == 2" class="row px-4 pb-4">
            <div class="col-12">
              <span class="mt-5">رمز یکبار مصرف پیامک شده و رمز عبور جدید خود را وارد کنید</span>
            </div>
            <div class="col-12 mt-3">
              <input type="text" autocomplete="new-password" v-model="TempPass" placeholder="رمز یکبار مصرف" class="form-control no-border text-center" />
            </div>
            <div class="col-12 mt-3">
              <input type="password" autocomplete="new-password" v-model="NewPass" placeholder="رمز جدید" class="form-control no-border text-center" />
            </div>
            <div class="col-12 mt-3">
              <input type="password" autocomplete="new-password" v-model="NewPassRepeat" placeholder="تکرار رمز جدید" class="form-control no-border text-center" />
            </div>
            <div class="col-12 mt-2 px-4 text-center">
              <button @click="ChangePass()" class="btn-dark w-100 mt-4 btn">تنظیم رمز جدید</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      stage: 1,
      PhoneNumber: '',
      NewPassRepeat: '',
      NewPass: '',
      TempPass: '',
    }
  },
  methods: {
    SemdSMS() {
      console.log(this.PhoneNumber=='');
      if (this.PhoneNumber==''){
          this.$mySweetDefaultTost('خطا', ' شماره همراه الزامی است !', 'warning', 2000)
      }
      else{
      var DataAxiosSemdSMS = { Method: 'POST', Action: 'RememberPassword/GetUserByMobile', ArryfildValue: { userMobile: this.PhoneNumber } }
            this.$PostData(DataAxiosSemdSMS).then((result) => {
              if (result.status == 'success') {
                this.$mySweetDefaultTost('عملیات موفق', result.msg, 'success', 2000)
                this.stage = 2
              } else {
                this.$mySweetDefaultTost('مشکلی بوجود اومده!!', result.msg, 'error', 2000)
              }
            })
      }
    },
    ChangePass() {
      if (this.NewPass != this.NewPassRepeat) {
        this.$mySweetDefaultTost('خطا', 'رمز جدید و تکرارش باهم برابر نیستنتد', 'warning', 2000)
      } else {
        if (this.NewPass.length < 5) {
          this.$mySweetDefaultTost('خطا', 'طول رمز عبور نباید کمتر از 5 کارکتر باشد', 'warning', 2000)
        } else {
          var DataAxiosSemdSMS = { Method: 'POST', Action: 'RememberPassword/ChangePass', ArryfildValue: { newPass: this.NewPass, tempPass: this.TempPass, usermobile: this.PhoneNumber } }
          this.$PostData(DataAxiosSemdSMS).then((result) => {
            if (result.status == 'success') {
              this.$mySweetDefaultTost('عملیات موفق', result.msg, 'success', 2000)
              this.$router.push({
                name: 'Login',
              })
            } else {
              this.$mySweetDefaultTost('مشکلی بوجود اومده!!', result.msg, 'error', 2000)
            }
          })
        }
      }
    },
  },
}
</script>
<style></style>
